import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Pagination, Form, DropdownButton, Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import _ from 'lodash';
import Confirm from '../../../components/Modal/Confirm';

import Loading from '../../../components/Loading/Loading';
import pagination from '../../../utils/pagination';
import throttle from '../../../utils/throttle';
import { getPartners, deletePartner } from '../PartnersActions';

import filterImage from '../../../assets/images/filter-icon.svg';
import deleteIcon from '../../../assets/images/delete-icon.svg';
import RemoteLinkIcon from '../../../assets/images/open-in-new.svg';

import '../../../assets/styles/_table.scss';

class PartnersTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFormat: 'DD-MM-YYYY',
      sort: '-createdAt',
      search: '',
      sortOptions: [
        {
          name: 'Name: A to Z',
          value: 'name',
        },
        {
          name: 'Name: Z to A',
          value: '-name',
        },
        {
          name: 'Email: A to Z',
          value: 'email',
        },
        {
          name: 'Email: Z to A',
          value: '-email',
        },
        {
          name: 'Created at: newest first',
          value: '-createdAt',
        },
        {
          name: 'Created at: oldest first',
          value: 'createdAt',
        },
        {
          name: 'No of accounts: highest first',
          value: '-accounts',
        },
        {
          name: 'No of accounts: lowest first',
          value: 'accounts',
        },
      ],
    };

    this.getPartnersThrottled = throttle(this.getPartners, 500, this);
  }

  componentDidMount() {
    this.getPartners();
  }

  handleChange = (ev) => {
    this.setState({ search: ev.target.value });
    this.getPartnersThrottled();
  };

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

  applySort = (sort) => {
    this.setState({ sort }, this.getPartners);
  };

  goto = (page = 1) => {
    if (page < 1) {
      page = 1;
    }

    this.getPartners(page);
  };

  getPartners = (page) => {
    const { sort, search } = this.state;
    this.props.getPartners({
      sort,
      search,
      page,
    });
  };

  delete = (partnerId) => {
    const { sort, search } = this.state;
    this.props.deletePartner(partnerId, {
      sort,
      search,
    });
  };

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 20, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }
    return (
      <Pagination>
        {pages.currentPage > 1 && <Pagination.First onClick={() => this.goto(1)} />}
        {pages.currentPage > 1 && <Pagination.Prev onClick={() => this.goto(pages.currentPage - 1)} />}
        {pages.pages.map((p, i) => {
          return (
            <Pagination.Item key={i} active={p === pages.currentPage} onClick={() => this.goto(p)}>
              {p}
            </Pagination.Item>
          );
        })}
        {pages.currentPage < pages.totalPages && <Pagination.Next onClick={() => this.goto(pages.currentPage + 1)} />}
        {pages.currentPage < pages.totalPages && <Pagination.Last onClick={() => this.goto(pages.totalPages)} />}
      </Pagination>
    );
  };

  renderRow = (partner, i) => {
    return (
      <tr key={i}>
        <td><p>{partner.email}</p></td>
        <td><p>{partner.name}</p></td>
        <td><p>{partner.refId}</p></td>

        {this.props.user.partner && this.props.user.partner.role === 'owner' ? (
          <td><p>{partner.activeAccounts}</p></td>
        ) : (
          <td><p>{partner.accounts}</p></td>
        )}

        {this.props.user.partner && this.props.user.partner.role === 'owner' && (
          <td>
            <div className='action-btn'>
              <OverlayTrigger
                overlay={<Tooltip id="remote_login" className='tooltip_dark max-width-200'>Remote Login</Tooltip>}>
                <a href={`https://portal.getnave.com/auth/remote/${partner.userId}`} rel="noopener noreferrer" target="_blank" className='btn btn-icon btn-md btn-secondary'>
                  <img src={RemoteLinkIcon} alt='#'/>
                </a>
              </OverlayTrigger>
              
              {this.props.user.partner.id !== partner._id && (
                <Confirm
                  body={
                    <p>
                      Are you sure you want to delete <br />
                      this partner?
                    </p>
                  }
                  confirmText="Delete"
                  icon={deleteIcon}
                  title="Delete partner"
                  onConfirm={() => this.delete(partner._id)}
                >
                  <Button disabled={partner.isDeleting} variant='delete' className='btn-icon btn-md'><img src={deleteIcon} alt='#' /></Button>
                </Confirm>
              )}
            </div>
          </td>
        )}
      </tr>
    );
  };

  renderSelected = (type) => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type],
    });
    return selected ? selected.name : '';
  };

  render() {
    const { isLoading, results, total } = this.props;

    return (
      <div>
        <div className='table-content'>
          <div className='table-filter'>
            <h2>Partners</h2>
            <div id="filter-content" className='filter-content'>
              <Form.Group controlId="sort" className="white filter-dropdown">
                <DropdownButton
                  className="form-dropdown sort w-260"
                  id="dropdown-item-button"
                  title={this.renderSelected('sort')}
                >
                  {this.state.sortOptions.map((f, i) => {
                    return (
                      <Dropdown.Item
                        key={i}
                        as="button"
                        className={this.state.platform === f.value ? 'active' : ''}
                        onClick={() => this.applySort(f.value)}>
                        {f.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Form.Group>
              <Form.Group controlId="Search" className="search-form">
                <Form.Control
                  type="text"
                  name="search"
                  placeholder="Search"
                  onChange={this.handleChange}
                  value={this.state.search}
                />
              </Form.Group>
            </div>
            
            <div className='filter-button' onClick={this.toggleFilter}>
              <img alt="filter" src={filterImage} />
            </div>
          </div>

          {isLoading && (
            <div className='table-loading'>
              <Loading />
            </div>
          )}
          {!isLoading && total === 0 && (
            <div className='no_data'>
              <p> No data available </p>
            </div>
          )}
          <div className='table'> 
            <table>
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Name</th>
                  <th>Referral No</th>
                  {this.props.user.partner && this.props.user.partner.role === 'owner' ? (
                    <th>Active Accounts</th>
                  ) : (
                    <th>Accounts</th>
                  )}
                  <th style={{ width: '120px'}}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {!isLoading && results.map((p, i) => this.renderRow(p, i))} 
              </tbody>
            </table>
          </div>
        </div>
        {total > 0 && this.renderPagination()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getPartners: (opt) => dispatch(getPartners(opt)),
    deletePartner: (id) => dispatch(deletePartner(id)),
  };
};

function mapStateToProps(state) {
  return {
    results: state.partners.results,
    isLoading: state.partners.isLoading,
    page: state.partners.page,
    total: state.partners.total,
    user: state.auth.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnersTable);
